import * as React from 'react';
import { ConnectedListContainer } from '../../generic/components/list-container';
import { GenericListItem } from './list-item';
import { ConnectedFiltersHeader } from '../../common/components/filters-header';
import { ConnectedFilterTextbox } from '../../common/components/filter-textbox';

import { ConnectedSort } from '../../common/components/sort-options';
import { ConnectedClearAll } from '../../common/components/clear-all';
import ConnectedDashBoard from '../../common/components/result-dashboard';
import { ConnectedScrollToTop } from '../../common/components/scroll-to-top';
import { AppExternalProps } from '../../event/components/app';

import { connect } from 'react-redux';
import { IAppState } from '../../common/classes/app';
import { ConnectedTypeFilter } from './type-filter';

interface StateToProps {
    isMobile: boolean;
    query: string;
}

type ProviderAppProps = StateToProps & AppExternalProps;

const ProviderAppBase: React.StatelessComponent<ProviderAppProps> = props => {
    return (
        <div>
            <div className="adage-search-input">
                <div className="adage-search-input-inner">
                    <h1>Search</h1>
                    <ConnectedFilterTextbox clickToSubmit={true} property="QueryValue" title="" defaultTextBoxValue={props.searchBoxDefault} showMoreLink={false} />
                </div>
            </div>
            <div className="adage-search">
                <div className="adage-search-rail">
                    <div className="adage-search-filters adage-search-rail-inner adage-search-rail-inner-js">

                        <ConnectedFiltersHeader />
                        <div id="searchFilters" className="adage-search-filters-content" aria-hidden={props.isMobile ? "true" : null}>
                            <div className="adage-search-reset">
                                <ConnectedClearAll text="Clear All" />
                            </div>

                            <div className="adage-search-filters-facets">
                                <div className="adage-search-filters-facets-column">
                                    <div className="adage-search-facet-group">

                                        <ConnectedTypeFilter property="type" title="ummm" />
                                        <div className="bold">Not what you are looking for?</div>

                                        <div className="adage-form-row">
                                            <a href={window['searchPageURLs'].providers + "?q=" + (props.query == undefined ? "" : props.query)}>Search Providers</a>
                                        </div>
                                        <div className="adage-form-row">
                                            <a href={window['searchPageURLs'].locations + "?q=" + (props.query == undefined ? "" : props.query)}>Search Locations</a>
                                        </div>
                                        <div className="adage-form-row">
                                            <a href={window['searchPageURLs'].events + "?q=" + (props.query == undefined ? "" : props.query)}>Search Events</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
                <div className="adage-search-main">

                    <ConnectedListContainer itemType="Providers" listItemComponent={props => <GenericListItem key={props.id} {...props} />} />
                </div>

                <ConnectedScrollToTop />
            </div>
        </div>

    )
}

function mapStateToProps(state: IAppState): StateToProps {
    return {
        isMobile: state.responsiveState.isMobile,
        query: state.filtersState.filters["QueryValue"]
    }
}

export const ProviderApp = connect(mapStateToProps)(ProviderAppBase);